import { createContext } from 'react';
import FeatureFlags from '../types/api/FeatureFlags';

const FeatureContext = createContext<FeatureFlags | null>(null);

export default FeatureContext;
